import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { ZERO_HYPHEN } from '@shared/constants/format';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-[1px] rounded-[8px] border p-[10px]',
  },
  imports: [CheckboxComponent, IconComponent],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'analytic-card',
  template: `
    <div class="flex flex-col gap-[7px]">
      @if (title()) {
        <div class="text-[14px] font-medium leading-[18px] text-aux-gray-dark-1">
          {{ title() }}
        </div>
      }
      <div class="text-[24px] font-semibold leading-[32px] text-aux-gray-darkest">
        {{ value() || longDash }}
      </div>
    </div>
    @if (showCheckbox()) {
      <div class="flex h-[16px] items-center">
        <aux-checkbox
          [id]="'analytic-card-checkbox-' + checkboxLabel()"
          [checked]="checkboxValue()"
          (customChange)="checkboxValue.set($event)"
          class="text-[14px] leading-[16px] text-aux-gray-dark-1 [&_label]:ml-[6px]"
          [pendoTag]="pendoTag()"
        >
          {{ checkboxLabel() }}
        </aux-checkbox>
      </div>
    }
    @if (showTrend()) {
      @let isDown = trendConfig().direction === 'down';
      <div class="flex gap-[2px]">
        @if (trendConfig().showDirection) {
          <aux-icon
            [name]="trendConfig().direction === 'down' ? 'ArrowDown' : 'ArrowUp'"
            [size]="16"
          />
        }

        <div class="flex gap-[4px]">
          @if (trendConfig().showValue) {
            <div
              class="text-[12px] font-medium leading-[16px] text-aux-gray-dark-1"
              [class.text-aux-red-dark]="isDown"
            >
              {{ trendConfig().value || longDash }}
            </div>
          }

          @if (trendConfig().showPercentage) {
            <!-- if we are showing value and percentage, we need a seperator -->
            @if (trendConfig().showValue) {
              <div class="text-[12px] font-medium leading-[16px] text-aux-gray-dark">|</div>
            }

            <div
              class="text-[12px] font-medium leading-[16px] text-aux-gray-dark-1"
              [class.text-aux-red-dark]="isDown"
            >
              {{ trendConfig().percentage || longDash }}
            </div>
          }
        </div>

        <div class="ml-[5px] text-[12px] leading-[16px] text-aux-gray-dark-1">
          {{ trendConfig().label }}
        </div>
      </div>
    }
  `,
})
export class AnalyticCard {
  checkboxValue = model<boolean>(false);

  checkboxLabel = input<string>('');
  pendoTag = input<string>('');
  showCheckbox = input<boolean>(false);
  showTrend = input<boolean>(false);
  title = input<string>('');
  trendConfig = input<{
    direction: 'down' | 'up';
    label: string;
    percentage: string;
    showDirection: boolean;
    showPercentage: boolean;
    showValue: boolean;
    value: string;
  }>({
    direction: 'down',
    label: 'Since last month',
    percentage: '',
    showDirection: false,
    showPercentage: false,
    showValue: false,
    value: '',
  });
  value = input<string>('');

  longDash = ZERO_HYPHEN;
}
